import React, { Fragment } from 'react';
import langs from "../../langs/phpIndex";
import DashIcon from "../../DashIcon";
import i18n from 'i18n-js';

import Maps, {setupMap} from "../../Maps";

import {string_to_color, generateRandomColors, hexToRgbA, dataFind, parsePHPtime, isBusinessDay, api, hashCode, actionColors, lastWeekFunc, decimals, getPreviousWorkday, betterDepartmentTable, rgbToHex, rndRGB, departmentIDs, euclidian} from "../../baseFunctions";
import moment from "moment";

import {IP} from "../../baseFunctions";
import alasql from "alasql";
import "./chart.css";

export default class Chart extends React.Component {
	constructor(){
		super();
		this.chart = false;
		this.drawChart = this.drawChart.bind(this);
		this.drawTable = this.drawTable.bind(this);
		this.drawCustomChart = this.drawCustomChart.bind(this);
		this.dateHelper = this.dateHelper.bind(this);
		this.eventClick = false;
		this.tempData = null;
		this.tempElem = false;
		this.temp = {
			hoverRefs: [],
			hoverImgRefs: [],
			hoverPos: [],
		};
		this.state = {
			i: 0
		};
	}
	componentDidUpdate(prevProps, prevState){
		if(prevState.i === this.state.i)
		{
			this.draw();
		}
	}
	componentDidMount(){
		if(window.tempTable && Array.isArray(window.tempTable))
		{
			window.tempTable.forEach(d => d.destroy());
			window.tempTable = [];
		}
		this.draw();
		this.temp.hoverPos = this.temp.hoverRefs.map(ref => {
			ref.style.display = "initial";
			let temp = ref.getBoundingClientRect();
			ref.style.display = "none";
			return temp;
		});
	}

	dateHelper(d, human, customUnix = false)
	{
	  var ret = [];
	  var now = customUnix ? moment(customUnix) : moment();
	  for(var i = 0; i <= d; i++)
	  {
		ret.push(human ? now.startOf('day').format("DD MMM YY") : now.startOf('day').unix());
		now = now.subtract(1, 'day');
	  }
	  ret.reverse();
	  return ret;
	}

	dateMaker = (human, start, end) =>
	{
	  var ret = [];
	  let now = moment(start).startOf("day");
	  let target = moment(end).endOf("day");
	  while(now.unix() < target.unix())
	  {
		console.log(now.unix() < target.unix(), now.unix(), target.unix());
		ret.push(human ? now.startOf('day').format("DD MMM YY") : now.startOf('day').unix());
		now = now.add(1, 'day');
	  }
	  console.log(now.unix() < target.unix(), now.unix(), target.unix());
	  ret.reverse();
	  return ret;
	}

	draw(){
		let lang = this.props.lang ? langs[this.props.lang] : {};
		const TYP = this.props.type;
		const DAT = this.props.data;
		window.Chart.defaults.global.animation.duration = 500;
		let data;
		switch(TYP)
		{
			case "DEPARTMENT_INFO":
				const getIDs = dep => [dep.id, ...dep.children.map(d => getIDs(d)).flat()];
				console.log("DEPARTMENT_INFO", DAT.allObs);
				const OBS_DATA = alasql('SELECT * FROM ? WHERE `unix` > ? AND `unix` < ? ', [DAT.allObs, this.props.from * 1000, this.props.to * 1000]);
				const depTable = betterDepartmentTable(DAT.allDepartments.data, true);//DAT.allDepartments.map(dep => betterDepartmentTable(dep, true)).flat();//betterDepartmentTable(DAT.allDepartments.data);//.filter(data => data[2] !== 0);
		
				this.drawTable([[lang.ID, lang.NAME, lang.AMOUNT_IN_DEP], ...depTable.map(depData => {
					const IDs = getIDs(depData[3]);
					const USER_IDs = DAT.users.filter(user => IDs.includes(user.department)).map(usr => usr.id);
					// const USER_IDs = DAT.users.filter(usr => usr.department === depData[0]).map(d => d.id);//alasql('SELECT * FROM ? WHERE department = ? ',[DAT.users, depData[0]]).map(usr => usr.id);
					const OUR_OBS = OBS_DATA.filter(obs => USER_IDs.includes(obs.userID));
					console.log("OUR_OBS", OUR_OBS, USER_IDs, depData, IDs);

					return [depData[0], depData[1], OUR_OBS.length];
				})], depTable.map((depData, key, arr) => arr[key + 1] && depData[2] < arr[key + 1][2] ? {backgroundColor: "rgba(108, 96, 57, 0.69)", color: "#fff"} : {}), false);
				/*this.drawTable([[lang.ID, lang.NAME, lang.AMOUNT_IN_DEP], ...Object.keys(DAT.departments).map(depID => {
					const USER_IDs = alasql('SELECT * FROM ? WHERE department = ? ',[DAT.users, depID]).map(usr => usr.id);
					const OUR_OBS = OBS_DATA.filter(obs => USER_IDs.indexOf(obs.uID) !== -1);
					let depName = DAT.departments[depID];
					return [depID, depName, OUR_OBS.length];
				})]);*/
			break;
			case "REPORT_MAP":
			case "INFO_OBS_LINE":
			case "INFO_LINE":
			break;
			case "OBS_SHARE":
			break;
			case "RA_POINTS_PIE":
				data = DAT.raSumAnswers;
				//console.log("U woot", DAT);
				this.drawCustomChart(Object.keys(data), [{
			            "label": "Point",
			            "data": Object.keys(data).map((d, key, arr) => {
			            	return data[d];
			            }),
			            "fill": "#d5d5d5",
			            backgroundColor: Object.keys(data).map((d, key, arr) => hexToRgbA("#" + string_to_color(d, 20), 0.4)),
			            "borderColor": Object.keys(data).map((d, key, arr) => "#" + string_to_color(d, 20)),
			            "lineTension": 0.1
			        }], this.refs.canvas, "pie", {
				responsive: true
			});
			break;
			case "RA_POINTS_BARS":
				data = DAT.raSumAnswers;
				//console.log("U woot", DAT);
				this.drawCustomChart(Object.keys(data), [{
			            "label": "Point",
			            "data": Object.keys(data).map((d, key, arr) => {
			            	return data[d];
			            }),
			            "fill": "#d5d5d5",
			            backgroundColor: Object.keys(data).map((d, key, arr) => hexToRgbA("#" + string_to_color(hashCode(d), 10), 0.4)),
			            "borderColor": Object.keys(data).map((d, key, arr) => "#" + string_to_color(hashCode(d), 10)),
			            "lineTension": 0.1
			        }], this.refs.canvas, "bar", {
				responsive: true
			});
			break;
			case "USER_POINTS":
				//  a
				{
					const users = DAT.userPoints.filter(d => d.points > 0).map(d => ({
						...d,
						pointDiff: d.points - d.monthPoints
					})).sort((a, b) => b.pointDiff - a.pointDiff);
					//console.log("Points", users, this.props);

					this.drawTable([
						["#", i18n.t("Navn"), i18n.t("Afdeling"), i18n.t("Nye point")], 
						...users.map((user, i) => [i + 1, user.fullName, user.departmentName, `+${user.pointDiff}`])
					], [
						["#ffc92d", "#dcad23"],
						["rgb(209 209 209)", "rgb(209 209 209)"],
						["rgb(211 196 161)", "rgb(211 196 161)"],
				].map(d => ({
						backgroundColor: d[0],
						boxShadow: "1px 1px 17px 2px " + d[1],
					})), false);
				}
			break;
			case "RA_COMMENTS":
				let words = DAT.raComments;
				let sortedData = Object.keys(words).sort((a,b) => {
					if(words[a] < words[b])
					{
						return 1;
					}
					if(words[a] > words[b])
					{
						return -1;
					}
					return 0;
		    }).filter((d, key) => key < 50);
		    this.drawTable([["Optælling", "Ord", ""], ...sortedData.map((d) => [
						words[d],
						d,
						<div className="fakeLink" onClick={() => {
							let sure = window.confirm("Er du sikker på at du vil skjule '" +  d + "' fra listen?");
							if(sure)
							{
								api("POST", {"type": "filterWord", word: d}, (dat) => {
									//console.log("Got data", d, dat);
									this.props.reloadData();
									
								}, this.props.auth, true);
							}
						}}>
							<i className="fa fa-trash" aria-hidden="true"></i>
						</div>
					])]);
			break;
			case "OBS_TYPES":
				this.drawCustomChart(Object.keys(DAT.obsStats.count), Object.keys(DAT.obsStats.count).map((key, i) => {//Object.keys(DAT.obsStats.count), Object.keys(DAT.obsStats.count).map((key) => {
					const d = DAT.obsStats.count[key];
					let COLOR = string_to_color(key, 28, false);
					const xSum = DAT.obsStats.keys.x.map(xKey => d[xKey] || 0).reduce((count, curr) => count + curr, 0);
					return {
						label: key,
						backgroundColor: "#" + rgbToHex(COLOR),
						borderColor: "#" + rgbToHex(COLOR),
						borderWidth: 1,
						data: DAT.obsStats.keys.x.map((xKey, n) => n === i ? xSum : 0)//Object.values(d)//.map(d => Math.random() * 50)
					};
					}), this.refs.canvas, "horizontalBar", {
						responsive: true,
						legend: {
				position: 'bottom',
				display: true,
				},
				"scales": {
					"yAxes": [{
						"ticks": {
							"beginAtZero": true
						},
						stacked: true,
					}],
				},
				tooltips: {
				   mode: 'index',
				   axis: "y",
				   //intersect: false,
				   callbacks: {
						label: function(tooltipItem, data) {
							if(typeof tooltipItem.xLabel === "number" && !window.isNaN(tooltipItem.xLabel))
							{
								const target = DAT.obsStats.count[tooltipItem.yLabel];
								const key = DAT.obsStats.keys.x[tooltipItem.datasetIndex];
								// console.log("Label", tooltipItem.datasetIndex, tooltipItem);
								if(target && target[key] && target[key] > 0)
								{

									
									return `${key}: ${target[key]}`;
								}
							// 	console.log(target, key);
							//   var label = data.datasets[tooltipItem.datasetIndex].label || '';
		
							//   if (label) {
							// 	  label += ': ';
							//   }
							//   label += tooltipItem.xLabel;
							//   return label;
							}
							return "";
						}
					  }
				 } 
			});




				//console.log("OBS TYPES", this.props);
	// 			let stats = DAT.obsStats;
	// 			/*this.drawCustomChart(Object.keys(stats), Object.keys(stats).map(d, key) => {
    //                 name: keys[key],
    //                 data: Object.keys(data).map((typeI) => {
    //                   const VALUE = data[typeI][keys[key]];
    //                   return VALUE ? VALUE : null;
    //                 })
    //               });*/
    //       let keys = [];//Object.keys(stats);
    //       Object.keys(stats).map((d) => {
    //       	if(keys.indexOf(d) === -1)
    //       	{
    //       		keys.push(d);
    //       	}
    //       	Object.keys(stats[d]).map((d) => {
    //       		if(keys.indexOf(d) === -1)
    //         	{
    //         		keys.push(d);
    //         	}
    //       	});
    //       });
    //       let test = keys.filter((d) => Object.keys(stats).indexOf(keys[d]) === -1).map((d, key) => {
    //       return {
    //         name: keys[key],
    //         data: Object.keys(stats).map((typeI) => {
    //           const VALUE = stats[typeI][keys[key]];
    //           return VALUE ? VALUE : null;
    //         })
    //       };
	// 	});
	// 	let usedColors = [];
    //       //console.log("HM?????", test);
    //     this.drawCustomChart(Object.keys(stats), test.map((d) => {
	// 		let orgSeed = d.name.toString();
	// 		let nameSeed = orgSeed;
	//   let COLOR = string_to_color(nameSeed, 28, false);
	//   /*let i = 0; 
	//   while(usedColors.length > 0 && usedColors.map(d => euclidian(d, COLOR)).sort((a, b) => b - a).find((d, k) => k === 0) > 60)
	//   {
	// 	COLOR = rndRGB();//string_to_color(nameSeed, 28, false);
	// 	i++;
	// }
	// console.log("Seed length", nameSeed.length, usedColors.map(d => euclidian(d, COLOR)).sort((a, b) => b - a).find((d, k) => k === 0));
	// console.log(rgbToHex(COLOR));
	//   usedColors.push(COLOR);*/
    //   return {
    //     label: d.name,
    //     backgroundColor: "#" + rgbToHex(COLOR),
    //     borderColor: "#" + rgbToHex(COLOR),
    //     borderWidth: 1,
    //     data: d.data
    //   };
    // }), this.refs.canvas, "horizontalBar", {
	// 						responsive: true,
	// 						/*tooltips: {
	// 							mode: "index",
	// 							intersect: false,
	// 						},*/
	// 						legend: {
	// 	            position: 'bottom',
	// 	            display: true,//this.props.hideLegend ? false : (window.innerWidth >= 1400),
	// 	          },
	// 						/*hover: {
	// 							mode: "index",
	// 							intersect: false
	// 						},*/
	// 		        "scales": {
	// 		            "yAxes": [{
	// 		                "ticks": {
	// 		                    "beginAtZero": true
	// 		                }
	// 		            }],
	// 		        },
	// 		        tooltips: {
    //        mode: 'index',
    //        axis: "y",
    //        //intersect: false,
    //        callbacks: {
    //             label: function(tooltipItem, data) {
    //                 if(typeof tooltipItem.xLabel === "number" && !window.isNaN(tooltipItem.xLabel))
    //                 {
    //                   var label = data.datasets[tooltipItem.datasetIndex].label || '';

    //                   if (label) {
    //                       label += ': ';
    //                   }
    //                   label += tooltipItem.xLabel;
    //                   return label;
    //                 }
    //                 return "";
    //             }
    //           }
    //      } 
	// 		    });


        /*[{
			            "label": "Typer",
			            "data": Object.keys(stats).map((d, key, arr) => {
			            		console.log(d, key, arr);
			            	return [0, 10,0];
			            }),
			            "fill": "#d5d5d5",
			            backgroundColor: 'rgba(42, 63, 84, 0.74)',
			            "borderColor": "rgba(42, 63, 84, 0.74)",
			            "lineTension": 0.1
			        }]*/
			break;
			case "DASH_LINE":
				//console.log("Dashboard line test", this.props);
				//let days = intRange(30);
				const NOW = this.props.to * 1000;
				let check = moment(NOW).subtract(2, 'weeks').unix();//NOW - WEEK;

				let data = DAT.OBS.filter(obs => obs.time > check);
				//console.log(DAT.type, " data", data, DAT.OBS, check, DAT);
				var ctx = this.refs.canvas.getContext("2d");
				/*var gradientFill = ctx.createLinearGradient(500, 0, 100, 0);
				gradientFill.addColorStop(0, "rgba(128, 182, 244, 0.6)");
				gradientFill.addColorStop(1, "rgba(244, 144, 128, 0.6)");*/


				this.drawCustomChart(this.dateHelper(14, 1), [{
			            "label": "Point",
			            "data": this.dateHelper(14, 0, NOW).map((d, key, arr) => {
			            	let lastUnix = key === 0 ? moment(NOW).unix() : arr[key - 1];
			        			let temp = alasql('SELECT * FROM ? WHERE time > ? AND time < ? ',[data, lastUnix, d]);

			            	return temp.length;
			            }),

			            "fill": false,
			            "borderColor": "rgba(26, 187, 156, 0.32)",//'rgba(122, 158, 197, 0.32)',
			            "lineTension": 0.1
			        }], this.refs.canvas, "line", 
			        {
			        	responsive: true,
			        	title: {
				    			display: false,
				    		},
				    		legend: {
				    			display: false,
				    		},
				    		tooltips: {
				    			enabled: false,
				    		},
				    		elements: {
                    point:{
                        radius: 0
                    }
                },
                scaleBeginAtZero: true,
						    scales: {
						        xAxes: [{
						            gridLines: {
						            		drawBorder: false,
						                display:false,
						            },
						            ticks: {
						                display: false,
						                min: 0,
    												beginAtZero: true
						            }
						        }],
						        yAxes: [{
						            gridLines: {
						            		drawBorder: false,
						                display:false
						            },
						            ticks: {
						                display: false,
						                min: 0,
    												beginAtZero: true
						            }  
						        }]
						    }
						});
			break;
			case "LAST_RA_TABLE":
				let startDate = moment(this.props.from * 1000);
				let endDate = moment(this.props.to * 1000);
				var now = startDate, buisnessDays = [];

				while (now.isBefore(endDate) || now.isSame(endDate)) {
					if(isBusinessDay(now))
					{
						buisnessDays.push(now.clone());
					}
					now.add(1, 'days');
				}

				let today = moment();
				if(!isBusinessDay(today))
				{
					today = getPreviousWorkday();
				}
				today = today.startOf("day");
				let todayEnd = moment(today).endOf("day");
				
				let lastWorkDay = getPreviousWorkday(today);
				let lastWorkDayEnd = moment(lastWorkDay).endOf("day");

				let intervalDat = alasql('SELECT * FROM ? WHERE time >= ? AND time < ? ORDER BY time DESC',[DAT.ra, this.props.from, this.props.to]);
				this.drawTable([[lang.ID, lang.NAME, ...lang.RA_TABLE_EXTRAS, lang.LAST_RA], ...DAT.users.filter(d => d.raWarn === "1").map((d) => {
					let lastRA = dataFind([{
							key: "createdBy",
							type: "=",
							value: d.id.toString(),
						}], {
							key: "time",
							type: "ASC",
						}, 1, DAT.ra);
						let myRAs = alasql('SELECT * FROM ? WHERE createdBy = ? AND boundTo = "0" ORDER BY time DESC',[intervalDat, d.id.toString()]);
						//console.log(myRAs, DAT.ra);
						let todayStmt = alasql('SELECT * FROM ? WHERE time >= ? AND time < ? AND createdBy = ? AND boundTo = "0" LIMIT 1',[myRAs, today.unix(), todayEnd.unix(), d.id.toString()]);
					let yesterdayStmt = alasql('SELECT * FROM ? WHERE time >= ? AND time < ? AND createdBy = ? AND boundTo = "0" LIMIT 1',[myRAs, lastWorkDay.unix(), lastWorkDayEnd.unix(), d.id.toString()]);
	
					let colorStatus = 0;
					let colorTitle = "Har hverken lavet en RA i dag, eller igår.";
					if(todayStmt.length > 0)
					{
						colorStatus = 2;
						colorTitle = yesterdayStmt.length > 0 ? "Har lavet en RA i dag og igår" : "Har lavet en RA i dag";
					}else if(yesterdayStmt.length > 0)
					{
						colorStatus = 1;
						colorTitle = "Har ikke lavet en RA i dag, men igår.";
					}
					
					let periodData = buisnessDays.map(day => alasql('SELECT * FROM ? WHERE time >= ? AND time < ? AND createdBy = ? AND boundTo = "0"',[myRAs, day.startOf("day").unix(), day.endOf("day").unix(), d.id.toString()]).length);
					let periodDiff = periodData.reduce((a, b) => a + b, 0) / buisnessDays.length;
					let periodStatus = 0;
					let periodTitle = "Har lavet en RA under 60% af hverdagene i perioden.";
					if(periodDiff >= 0.9)
					{
						periodStatus = 2;
						periodTitle = "Har lavet en RA over 90% af hverdagene i perioden.";
					}else if(periodDiff >= 0.6)
					{
						periodStatus = 1;
						periodTitle = "Har lavet en RA over 60% af hverdagene i perioden.";
					}
					
					return [
						d.id,
						d.name,
						<p style={{textAlign: "center", color: actionColors[colorStatus]}} title={colorTitle}>
							<div style={{display: "none"}}>{actionColors[colorStatus]}</div>
							<i className="fa fa-circle" aria-hidden="true"></i>
                        </p>,
						<p style={{textAlign: "center", color: actionColors[periodStatus]}} title={periodTitle}>
							<div style={{display: "none"}}>{actionColors[periodStatus]}</div>
							<i className="fa fa-circle" aria-hidden="true"></i>
						</p>,
						myRAs.length,
						(myRAs.length / buisnessDays.length).toFixed(2),
						lastRA.length > 0 ? parsePHPtime(lastRA[0].time) : lang.NO_DATA,
					];
				})]);
			break;
			case "LAST_RA_OBS_TABLE":
			//console.log("OBS RA TABLE", this.props);
				if(!DAT.users || !DAT.obs)
				{
					return;
				}
				this.drawTable([[lang.ID, lang.NAME, lang.LAST_OBS], ...DAT.users.filter(user => user.deleted === 0).map((d) => {
					// let lastRA = dataFind([{
					// 		key: "userID",
					// 		type: "=",
					// 		value: d.id.toString(),
					// 	}], {
					// 		key: "time",
					// 		type: "ASC",
					// 	}, 1, DAT.ra);
					let lastOBS = dataFind([{
							key: "userID",
							type: "=",
							value: d.id,//.toString(),
						}], {
							key: "unix",
							type: "ASC",
						}, 1, DAT.obs);

					// const lastOBS = DAT.obs.filter(d => d);
					return [
						d.id,
						d.fullName,
						lastOBS.length > 0 ? parsePHPtime(lastOBS[0].unix / 1000) : lang.NO_DATA,
					];
				})]);
			break;
			case "OBS_LOCAL_MONTH_KPI":
				{
					const LAST_DATASET_QUERY = alasql('SELECT * FROM ? ORDER BY time DESC LIMIT 1', [this.props.data.obs]);
					const LAST_DATASET = LAST_DATASET_QUERY.length > 0 ? moment.unix(LAST_DATASET_QUERY[0].time) : moment();
					const MONTH_START = moment(LAST_DATASET).startOf("month");
					const MONTH_END = moment(LAST_DATASET).endOf("month");

					const MONTH_START_LAST_YEAR = moment().set("year", MONTH_START.year() - 1).set("month", MONTH_START.month()).startOf("month");
					const MONTH_END_LAST_YEAR = moment(MONTH_START_LAST_YEAR).endOf("month");
					//console.log("Data", this.props);
					const DATA_SET = this.props.data.obs.filter(d => d.time >= MONTH_START.unix() && d.time <= MONTH_END.unix());
					const DATA_SET_LASTY = this.props.data.allObs.filter(d => d.time >= MONTH_START_LAST_YEAR.unix() && d.time <= MONTH_END_LAST_YEAR.unix());
					console.log("Last year", DATA_SET_LASTY);
					console.log("This year", DATA_SET);
					const DEP_DATA = DATA_SET.reduce((obj, obs) => {
						if(!obj[obs.department])
						{
							obj[obs.department] = {
								data: [],
								lastY: DATA_SET_LASTY.filter(d => d.department === obs.department),
								name: this.props.data.departments[obs.department],
							};
						}
						obj[obs.department].data.push(obs);
						return obj;
					}, {});

						/*
Object.keys(DEP_DATA).map((d, i) => {
						let DEP = DEP_DATA[d];
						//console.log(i, DEP);
						return {
							label: DEP.name,
							backgroundColor: COLORS[i],
							borderColor: COLORS[i],
							barShowStroke :0,
							barRadius: 0,
							borderWidth: 1,
							data: Object.keys(DEP_DATA).map((_, key) => key === i ? DEP.data.length : 0)
						};
					})
						*/
					this.drawCustomChart(Object.keys(DEP_DATA).map(d => DEP_DATA[d].name || "UNKOWN"), [{
						label: "Current month",
						backgroundColor: "#D4E3F4",
						borderColor: "#B8CEE6",
						barShowStroke :0,
						barRadius: 0,
						borderWidth: 1,
						data: Object.keys(DEP_DATA).map(key => DEP_DATA[key].data.length)
					},{
						label: "Last year",
						backgroundColor: "#274162",
						borderColor: "#3F506A",
						barShowStroke :0,
						barRadius: 0,
						borderWidth: 1,
						data: Object.keys(DEP_DATA).map(key => DEP_DATA[key].lastY.length)
					}], this.refs.canvas, "horizontalBar", false, {
						legend: {
							display: false,
						},
						tooltips: {
							mode: 'index',
							axis: "y",
						}
					});
				}
			break
			case "OBS_LOCAL_KPI":
				{
					/*
					TODO: Brug allObs i stedet for obs, og sørg for at de overholder timepickeren.
					(Fucker ligenu ved f.eks 1/4 - 30/4)
					*/
					const LAST_DATASET_QUERY = alasql('SELECT * FROM ? ORDER BY time DESC LIMIT 1', [this.props.data.obs]);
					const LAST_DATASET = LAST_DATASET_QUERY.length > 0 ? moment.unix(LAST_DATASET_QUERY[0].time) : moment();
					const MONTH_START = moment(LAST_DATASET).startOf("month");
					const MONTH_END = moment(LAST_DATASET).endOf("month");

					const DATA_SET = this.props.data.obs.filter(d => d.time >= MONTH_START.unix() && d.time <= MONTH_END.unix());
					/*const USER_MAP = this.props.data.users.reduce((obj, usr) => {
						obj[usr.id] = usr;
						return obj;
					}, {});*/
					const DAYS = [...Array(LAST_DATASET.daysInMonth())].map((d, key) => key + 1);
					const DEP_DATA = DATA_SET.reduce((obj, obs) => {
						if(!obj[obs.department])
						{
							obj[obs.department] = [];
						}
						obj[obs.department].push(obs);
						return obj;
					}, {});
					
					let colors = generateRandomColors(Object.keys(DEP_DATA).length);
					this.drawCustomChart(DAYS, [
						...Object.keys(DEP_DATA).map((key, i, arr) => {
							let dep = DEP_DATA[key];
							let target = this.props.data.departments[key];
							target = target ? target : "UNKOWN";
							return {
								label: target,
								backgroundColor: colors[i],
								borderColor: colors[i],
								borderWidth: 1,
								data: DAYS.map(d => {
									let m = moment(MONTH_START).add((d - 1), "days");
									const DAY_START = moment(m).startOf("day").unix();
									const DAY_END = moment(m).endOf("day").unix();
									return dep.filter(d => d.time >= DAY_START && d.time <= DAY_END).length;
								})
							};
						}),
						
					], this.refs.canvas, "bar", false, {
						legend: {
							display: true,
							labels: {
								boxWidth: 5,
								fontSize: 8,
							}
						},
						tooltips: {
							// Disable the on-canvas tooltip
							enabled: false,
							mode: "index",
							intersect: false,
				
							custom: function(tooltipModel) {
								// Tooltip Element
								var tooltipEl = document.getElementById('chartjs-tooltip');
				
								// Create element on first render
								if (!tooltipEl) {
									tooltipEl = document.createElement('div');
									tooltipEl.id = 'chartjs-tooltip';
									tooltipEl.innerHTML = '<table></table>';
									document.body.appendChild(tooltipEl);
								}
				
								// Hide if no tooltip
								if (tooltipModel.opacity === 0) {
									tooltipEl.style.opacity = 0;
									return;
								}
				
								// Set caret Position
								tooltipEl.classList.remove('above', 'below', 'no-transform');
								if (tooltipModel.yAlign) {
									tooltipEl.classList.add(tooltipModel.yAlign);
								} else {
									tooltipEl.classList.add('no-transform');
								}
				
								function getBody(bodyItem) {
									return bodyItem.lines;
								}
				
								// Set Text
								if (tooltipModel.body) {
									var titleLines = tooltipModel.title || [];
									var bodyLines = tooltipModel.body.map(getBody);
				
									var innerHtml = '<thead>';
				
									titleLines.forEach(function(title) {
										innerHtml += '<tr><th>d.' + title + '</th></tr>';
									});
									innerHtml += '</thead><tbody>';
				
									bodyLines.forEach(function(body, i) {
										var colors = tooltipModel.labelColors[i];
										var style = 'background:' + colors.backgroundColor;
										style += '; border-color:' + colors.borderColor;
										style += '; border-width: 2px; padding: 5px;';
										var span = '<span style="' + style + '"></span>';

										const tempFix = Number(body[0].split(": ")[1]) > 0;
										if(tempFix)
										{
											innerHtml += '<tr><td>' + span + body + '</td></tr>';
										}
									});
									innerHtml += '</tbody>';
				
									var tableRoot = tooltipEl.querySelector('table');
									tableRoot.innerHTML = innerHtml;
								}
				
								// `this` will be the overall tooltip
								var position = this._chart.canvas.getBoundingClientRect();
				
								// Display, position, and set styles for font
								tooltipEl.style.opacity = 1;
								tooltipEl.style.position = 'absolute';
								tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
								tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
								tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
								tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
								tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
								tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
								tooltipEl.style.pointerEvents = 'none';
							}
						
						}
					});
				}
			break;
			case "OBS_KPI":
				if(!this.props.data.obsMonths)
				{
					return;
				}
				var insideFontColor = '255,255,255';
				// Font color for values above the bar
				var outsideFontColor = '0,0,0';
				// How close to the top edge bar can be before the value is put inside it
				var topThreshold = 20;
				
				var modifyCtx = function(ctx) {
					ctx.font = window.Chart.helpers.fontString(window.Chart.defaults.global.defaultFontSize, 'normal', window.Chart.defaults.global.defaultFontFamily);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'bottom';
					return ctx;
				};
				
				var fadeIn = function(ctx, obj, x, y, black, step) {
					var ctx = modifyCtx(ctx);
					var alpha = 0;
					ctx.fillStyle = black ? 'rgba(' + outsideFontColor + ',' + step + ')' : 'rgba(' + insideFontColor + ',' + step + ')';
					ctx.fillText(obj, x, y);
				};
				
				var drawValue = function(context, step) {
					var ctx = context.chart.ctx;

					context.data.datasets.forEach(function (dataset) {
						if(dataset.label.indexOf(lang.TARGET_MONTH) === -1)
						{
							for (var i = 0; i < dataset.data.length; i++) {
								var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
								var textY = (model.y > topThreshold) ? model.y - 3 : model.y + 20;
								fadeIn(ctx, dataset.data[i], model.x, textY, model.y > topThreshold, step);
							}
						}
					});
				};

				// Circle indicators
				const LAST_DATASET_QUERY = alasql('SELECT * FROM ? ORDER BY time DESC LIMIT 1', [this.props.data.obs || []]);
				const LAST_DATASET = LAST_DATASET_QUERY.length > 0 ? moment.unix(LAST_DATASET_QUERY[0].time) : moment();
				const LAST_DAY = LAST_DATASET.day();
				const LAST_MONTH_DAYS = LAST_DATASET.daysInMonth();
				const LAST_DATASET_DAY_OF_YEAR = moment(LAST_DATASET).dayOfYear();
				const LAST_MONTH = LAST_DATASET.month();

				
				const ytd_query = alasql('SELECT count(id) as c FROM ? WHERE time >= ? AND time <= ?', [
					this.props.data.obs || [], 
					moment(LAST_DATASET).startOf('year').unix(), 
					LAST_DATASET.unix()
				]);

				const YTD_SUM = this.props.data.obsMonths.this
								.filter((d, key) => key <= LAST_MONTH)
								.reduce((a, b) => a+b, 0)//ytd_query[0].c;
				const YTD_MIN = ((this.props.data.obsMonths.target * 12) * (LAST_DATASET_DAY_OF_YEAR / 365));
				const YTD_CHECK = YTD_SUM >= YTD_MIN;
				this.refs.ytdIndicator.style.backgroundColor = YTD_CHECK ? "green" : "red";
				this.refs.ytdIndicator.title = `${YTD_SUM} / ${Math.ceil(YTD_MIN)}`;

				const MONTH_SUM = this.props.data.obsMonths.this[LAST_MONTH];
				const MONTH_MIN = (this.props.data.obsMonths.target * (LAST_DAY / LAST_MONTH_DAYS));
				const MONTH_CHECK = MONTH_SUM >= MONTH_MIN;
				this.refs.monthIndicator.style.backgroundColor = MONTH_CHECK ? "green" : "red";
				this.refs.monthIndicator.title = `${MONTH_SUM} / ${Math.ceil(MONTH_MIN)}`;

				/*	let ctx = this.refs.canvas.getContext('2d');
				var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
				gradientStroke.addColorStop(0, '#3d4f63');
				gradientStroke.addColorStop(1, '#3d4f63');*/
				this.drawCustomChart([
					...lang.MONTHS,
					"YTM"
				], [
					{
						label: lang.TARGET_MONTH + ': ' +  this.props.data.obsMonths.target,
						data: [30, 25, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50].map(d => this.props.data.obsMonths.target),
			  
						backgroundColor: "transparent",
							  borderColor: "#e88c16",
							  borderWidth: 0,
						  borderDash: [10,10],
			  
						// Changes this dataset to become a line
						type: 'line',
						yAxisID: "y-axis-1"
					  },
					  {
						label: lang.OBS_LAST_YEAR,
						backgroundColor: "#7a9ec5",
						borderColor: "#3d4f63",
						borderWidth: 1,
						data: this.props.data.obsMonths.last,
						yAxisID: "y-axis-1"
					},
					{
					  label: lang.OBSERVATIONS,
					  backgroundColor: "#bb8430",
					  borderColor: "#3d4f63",
					  borderWidth: 1,
					  data: this.props.data.obsMonths.this,
					  yAxisID: "y-axis-1"
				  },
				
			  {
				label: i18n.t("Årligt resultat"),
				backgroundColor: "#bb8430",
				borderColor: "#3d4f63",
				borderWidth: 1,
				data: [
					...lang.MONTHS.map(d => NaN),
					this.props.data.obsMonths.this.reduce((a,b) => a + b, 0)
				],
				yAxisID: "y-axis-2"
			},
			{
				label: i18n.t("Årligt mål"),
				backgroundColor: "#e88c16",
				borderColor: "#e88c16",
				borderWidth: 1,
				data: [
					...lang.MONTHS.map(d => NaN),
					this.props.data.obsMonths.target * 12
				],
				yAxisID: "y-axis-2"
			},
			{
				label: i18n.t("Sidste års resultat"),
				backgroundColor: "#7a9ec5",
				borderColor: "#3d4f63",
				borderWidth: 1,
				data: [
					...lang.MONTHS.map(d => NaN),
					this.props.data.obsMonths.last.reduce((a,b) => a + b, 0)
				],
				yAxisID: "y-axis-2"
			}
				], this.refs.canvas, "bar", {
					responsive: true,
					maintainAspectRatio: false,
					tooltips: {
						enabled: false
					},
					hover: {
						animationDuration: 0
					},
					animation: {
						onComplete: function() {
							this.chart.controller.draw();
							drawValue(this, 1);
						},
						onProgress: function(state) {
							var animation = state.animationObject;
							drawValue(this, animation.currentStep / animation.numSteps);
						}
					},
					scales: {
						yAxes: [{
							type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
							display: true,
							position: "left",
							id: "y-axis-1",
							min: 0.5 
						}, {
							type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
							display: true,
							position: "right",
							id: "y-axis-2",
	
							// grid line settings
							gridLines: {
								drawOnChartArea: false, // only want the grid lines for one axis to show up
							},
						}],
					}
				}
				);
			break;
			case "POINTS_LINE":
				const RA = DAT.ra;
				var start = moment(this.props.from * 1000).startOf("day");
				var end = moment(this.props.to * 1000).endOf("day").add(1, "day");
				var days = end.diff(start, 'days');
				
				this.drawCustomChart(this.dateHelper(days, 1, end), [{
					"label": i18n.t("Rapporter"),
					"data": this.dateHelper(days, 0, end).map((d, key, arr) => {
						return alasql('SELECT * FROM ? WHERE time > ? AND time < ? AND boundTo = "0" ',[RA, d, arr[key + 1]]).length;
					}),
					"fill": "#9c7373",
					backgroundColor: 'rgba(156, 115, 115, 0.74)',
					"borderColor": "rgba(156, 115, 115, 0.74)",
					"lineTension": 0.1
				},{
					"label": "Point",
					"data": this.dateHelper(days, 0, end).map((d, key, arr) => {
						return alasql('SELECT * FROM ? WHERE time > ? AND time < ? ',[RA, d, arr[key + 1]]).reduce((a, rep, curr) => {
							return rep.points + curr;
						}, 0);
					}),
					"fill": "#d5d5d5",
					backgroundColor: 'rgba(42, 63, 84, 0.74)',
					"borderColor": "rgba(42, 63, 84, 0.74)",
					"lineTension": 0.1
				}], this.refs.canvas);
			break;
			default:
				console.log("Default", this.props);
				this.drawChart();
			break;
		}
	}
	drawCustomChart(labels, data, target, type = "line", customOptions, extraOptions = {})
	{
		if(this.tempElem)
		{
			this.tempElem.destroy();
		}
		this.tempElem = new window.Chart(target, {
			    type,
			    "data": {
			        "labels": labels,
			        "datasets": data
			    },
			    "options": customOptions ? customOptions : {
							responsive: true,
							tooltips: {
								mode: "index",
								intersect: false,
							},
							hover: {
								mode: "index",
								intersect: false
							},
			        "scales": {
			            "yAxes": [{
			                "ticks": {
			                    "beginAtZero": true
			                }
			            }]
					},
					...extraOptions
			    }
			});

		if(this.props.onClick && !this.eventClick)
		{
			this.eventClick = true;
			this.refs.canvas.addEventListener("click", (evt) => {
				var activePoints = this.tempElem.getElementsAtEvent(evt);
				if (activePoints[0]) {
	        var chartData = activePoints[0]['_chart'].config.data;
	        var idx = activePoints[0]['_index'];

	        var label = chartData.labels[idx];
	        var value = chartData.datasets[0].data[idx];

	        this.props.onClick(label, value);
	      }
			});
		}
	}
	drawTable(rows, styles = [], enableDataTable = true)
	{
		this.tempData = (<table className="table table-striped jambo_table bulk_action" ref={(table) => {
			if(table && !this.props.fullPage && enableDataTable)
			{
				if(!window.tempTable)
				{
					window.tempTable = [];
				}
				window.tempTable.push(window.$(table).DataTable(langs[this.props.lang].DATA_OPTIONS));
			}
		}}>
				<thead>
					<tr>
						{
							rows[0].map((col, key) => <th key={key}>{col}</th>)
						}
					</tr>
				</thead>
				<tbody>
					{rows.map((cols, key) => key !== 0 ? <tr key={key} style={styles[key - 1] ? styles[key - 1] : {}}>
					{
						cols.map((col, key2) => <td key={key + "-" + key2}>{col}</td>)
					}
				</tr> : null)}
				</tbody>
				
			</table>);
		this.setState({
			i: this.state.i + 1
		});
	}
	drawChart(){
		if(this.chart)
		{
			this.chart.destroy();
		}
		let ctx = this.refs.canvas.getContext('2d');
		let labels = Object.keys(this.props.data);
    this.chart = new window.Chart(ctx, {
        type: this.props.type,
        data: {
            labels: labels,
            datasets: [{
                label: '',
                data: labels.map((d) => this.props.data[d]),
                backgroundColor: labels.map((d) => hexToRgbA("#" + string_to_color(d, 20), 0.4)),
                borderColor: labels.map((d) => "#" + string_to_color(d, 20)),
                borderWidth: 1
            }]
        },
        options: this.props.type === "pie" ? false : {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
	}
	doHover = (key, elem) => {
		/*let target = elem.target;
		let container = this.refs.hovr;
		let img = this.refs.hovrImg;
		let bounding = target.getBoundingClientRect();
		//container.innerHTML = '<img src="' + target.src + '"/>';
		img.src = target.src;
		container.style.left = (bounding.left - 463) + "px";
		container.style.display = "initial";*/
		elem = elem.target;
		let container = this.temp.hoverRefs[key]//this.refs.hovr;
		let img = this.temp.hoverImgRefs[key];
		let bounding = elem.getBoundingClientRect();

		container.style.top = (window.scrollY + (bounding.top - this.temp.hoverPos[key].top)) + "px";
		container.style.left = (bounding.left - this.temp.hoverPos[key].left) - 150 + "px";
		//container.style.left = (bounding.left * -1) + "px";
		container.style.display = "initial";
		img.src = elem.src;

	}
	hideHover = (key) => {
		//let target = elem.target;
		let container = this.temp.hoverRefs[key]//this.refs.hovr;
		let img = this.temp.hoverImgRefs[key];
		/*	console.log(target.src === img.src);
		if(target.src !== img.src &&0)
		{

			img.src = "";
			container.style.display = "none";
		}*/
		/*img.src = "";
		container.style.display = "none";*/
		if(container)
		{
			container.style.display = "none";
		}
	}
	intervalData = (data, start, end, specialTimeName = "time") => {
		return data.filter((d, key) => {
			return d[specialTimeName] > start && d[specialTimeName] < end;
		});
	}

	render(){
		const LANG = langs[this.props.lang];
		let data = this.props.data;
		const WEEK = 1*60*60*7;
		switch(this.props.type)
		{
			case "INFO_OBS_LINE":

			{ //Scope fix
				/*
					Gns. obs pr bruger
					Antal ubehandlet obs.
					Antal obs lavet af egne brugere

				*/
				const USER_IDs = data.users.map(d => d.id);
				const DEPARTMENTS = Object.keys(data.departments);
				let DEPARTMENT_STRING = DEPARTMENTS.join(",");//)"";
				// Object.keys(data.departments).forEach(d => {
				// 	if(DEPARTMENT_STRING.length > 0)
				// 	{

				// 		DEPARTMENT_STRING = DEPARTMENT_STRING + ',"' + d + '"';
				// 	}else{
				// 		DEPARTMENT_STRING = '"' + d + '"';
				// 	}
				// });

				const OBS_DATA = alasql('SELECT * FROM ? WHERE `unix` > ? AND `unix` < ? ',[data.allObs, this.props.from * 1000, this.props.to * 1000]);

				const OUR_OBS = OBS_DATA.filter(obs => USER_IDs.indexOf(obs.userID) !== -1);
				// console.log("OUR_OBS", OBS_DATA, OUR_OBS, data.allObs, this.props);
				const OBS_DATA_WEEK = alasql('SELECT * FROM ? WHERE `unix` > ? AND `unix` < ? ',[data.allObs, this.props.from - WEEK, this.props.to - WEEK]);
				const obsPercent = lastWeekFunc(OBS_DATA.length, OBS_DATA_WEEK.length);

				const UNHANDLED_OBS = OBS_DATA.filter(d => d.status === 0 && (d.department === null || DEPARTMENTS.includes(d.department.toString())));//alasql('SELECT * FROM ? WHERE status = "0"',[OBS_DATA]);

				const OTHER_OBS = OBS_DATA.filter(obs => USER_IDs.indexOf(obs.userID) === -1);//alasql('SELECT * FROM ? WHERE uID = ? ',[OBS_DATA, data.users.map(d => d.id)]);
				const OWN_OBS = OBS_DATA.length  - OTHER_OBS.length;

				const ACTIVE_USERS = data.users.filter(user => user.deleted === 0);
				/*console.log("Total OBS", OBS_DATA.length, "Own OBS", OUR_OBS.length, "Other OBS", OTHER_OBS.length);
				console.log("Total OBS", OBS_DATA, "Own OBS", OUR_OBS, "Other OBS", OTHER_OBS);

				console.log("Own", OUR_OBS.filter(obs => obs.id === 84232 || obs.id == 84156 || obs.id === 83664), OTHER_OBS.filter(obs => obs.id === 84232 || obs.id == 84156 || obs.id === 83664));*/

					return (<div className="row tile_count">
	            <DashIcon lang={this.props.lang} number={ACTIVE_USERS.length} icon="users" text={LANG.TOTAL_USERS} showData={() => this.props.showData(data.users, "USERS")}/>
	            <DashIcon lang={this.props.lang} number={OBS_DATA.length} icon="eye" text={LANG.TOTAL_OBS} percent={obsPercent['percent']} positive={obsPercent['higher']} showData={() => this.props.showData(OBS_DATA, "OBS")}>
	            	<Chart type="DASH_LINE" from={this.props.from} to={this.props.to} auth={this.props.auth} style={{"position": "absolute","height": "92%","width": "80%", zIndex: "0", maxHeight: "92%"}} data={{type: "TOTAL_OBS", OBS: OBS_DATA}}/>
	            </DashIcon>
	            <DashIcon lang={this.props.lang} number={OWN_OBS} icon="user" text={LANG.OBS_OWN_USR}>
	            	<Chart type="DASH_LINE" from={this.props.from} to={this.props.to} auth={this.props.auth} style={{"position": "absolute","height": "92%","width": "80%", zIndex: "0", maxHeight: "92%"}} data={{type: "OWN_OBS", OBS: OUR_OBS}}/>
	            </DashIcon>
	            <DashIcon lang={this.props.lang} number={OTHER_OBS.length} icon="user" text={LANG.OBS_OTH_USR} showData={() => this.props.showData(OTHER_OBS, "OBS")}>
	            	<Chart type="DASH_LINE" from={this.props.from} to={this.props.to} auth={this.props.auth} style={{"position": "absolute","height": "92%","width": "80%", zIndex: "0", maxHeight: "92%"}} data={{type: "OTHER_OBS", OBS: OTHER_OBS}}/>
	            </DashIcon>
	            <DashIcon lang={this.props.lang} number={Number((OBS_DATA.length / ACTIVE_USERS.length).toFixed(2))} digits={2} icon="user" text={LANG.OBS_PR_USR}/>
	            <DashIcon lang={this.props.lang} number={UNHANDLED_OBS.length} icon="exclamation-circle" text={LANG.OBS_WARN} showData={() => this.props.showData(UNHANDLED_OBS, "OBS")}/>
	        </div>);
        }
			break;
			
			case "REPORT_MAP":
				// return <div>Hej</div>
				return <Maps info={this.props.data.allObs.map(obs => ({
					title: obs.createdBy,
					link: `/#/reports/${obs.groupID}/${obs.id}`,
					linkText: "#" + obs.id,
				}))} data={this.props.data.allObs.map(obs => [Number(obs.lat), Number(obs.long)])} style={{height: "500px", width:"100%"}} />;
			break;
			case "INFO_LINE":
			{
				//console.log("OBS LKINE", data, this.props);
				let weekD = this.intervalData(data.ra, this.props.from - WEEK, this.props.to - WEEK);
				let weekDobs = this.intervalData(data.obs, this.props.from - WEEK, this.props.to - WEEK);
				const OBS_INT = this.intervalData(data.obs, this.props.from, this.props.to);

				const REPORTS = alasql('SELECT * FROM ? WHERE time > ? AND time < ? AND boundTo = "0" ', [data.ra, this.props.from, this.props.to]);
				const TOTAL_POINTS = REPORTS.reduce((a, rep, curr) => {
					return rep.points + curr;
				}, 0);
				const TOTAL_COMMENTS = REPORTS.reduce((a, rep, curr) => {
					return rep.comments + curr;
				}, 0);
			
				const USERS_LENGTH = Object.keys(data.users).length > 0 ? Object.keys(data.users).length : 1;
			
				const reportsPercent = lastWeekFunc(data.ra.length, weekD.length);
				const obsPercent = lastWeekFunc(OBS_INT.length, weekDobs.length);
					return (<div className="row tile_count">
	            <DashIcon lang={this.props.lang} number={Object.keys(data.users).length} icon="user" text={LANG['TOTAL_USERS']} showData={() => {}}/>
							
	            <DashIcon lang={this.props.lang} number={Object.keys(OBS_INT).length} icon="eye" percent={obsPercent['percent']} positive={obsPercent['higher']}  text={LANG['TOTAL_OBS']}>
	            	<Chart type="DASH_LINE" from={this.props.from} to={this.props.to} auth={this.props.auth} style={{"position": "absolute","height": "92%","width": "80%", zIndex: "0", maxHeight: "92%"}} data={{type: "TOTAL_OBS", OBS: OBS_INT}}/>
	            </DashIcon>
	            <DashIcon lang={this.props.lang} number={REPORTS.length} icon="archive" percent={reportsPercent['percent']} positive={reportsPercent['higher']} text={LANG['TOTAL_RA']}>
	            	<Chart type="DASH_LINE" from={this.props.from} to={this.props.to} auth={this.props.auth} style={{"position": "absolute","height": "92%","width": "80%", zIndex: "0", maxHeight: "92%"}} data={{type: "TOTAL_RA", OBS: REPORTS}}/>
	            </DashIcon>
	            <DashIcon lang={this.props.lang} number={decimals(TOTAL_POINTS/REPORTS.length, 2)} icon="envelope" text={LANG['POINT_PR_RA']}/>
	            <DashIcon lang={this.props.lang} number={decimals(TOTAL_POINTS/USERS_LENGTH, 2)} icon="user" text={LANG['POINT_PR_USR']}/>
	            <DashIcon lang={this.props.lang} number={decimals(TOTAL_COMMENTS/USERS_LENGTH, 2)} icon="commenting" text={LANG['COMMENT_PR_USR']}/>
	        </div>);
        }
			break;
			case "OBS_SHARE":
				return (<div className="container">
							{
								data.obsShared.obs.map((d, key) => {
									// let comment = data.obsShared.comments[d.id] ? data.obsShared.comments[d.id] : "";
									let images = data.obsShared.images.filter(img => img.id === d.id).map(img => img.value);
									return (<div className="row shareLine" key={key}>
								<div className="col-sm-8">
									<div className="title">
										#{d.id} - {d.firstName}, {d.departmentName}
									</div>
									{
										d.address ?
											<div className="title">
												{d.address}
											</div>
										: null
									}
									{d.comment}
									{/* {comment != "undefined" ? comment : ""} */}
									<div className="links">
										<a target="_blank" href={`/#/publicReport/${d.id}/${this.props.lang}/${d.answerHash}?autoprint`}>{LANG.EXTERNAL_REP}</a>
										{/* <a className="red-color" style={{display: "none"}}>{LANG.REMOVE}</a> */}
									</div>
								</div>
								<div  onMouseOut={() => this.hideHover(key)}>
									<div className="col-sm-4 imgContainer">
									{/* question.response.map(fileName => <img src={`${IP}/image/${fileName}`} */}
										{
											images.filter((_, key) => key < 4).map((img, imgI) => <img src={`${IP}/image/${img}`} onMouseOver={(elem) => this.doHover(key, elem)} style={{width: (25) + "%"}} key={imgI} />)
										}
									</div>
									<div ref={(ref) => this.temp.hoverRefs[key] = ref} className="imgHover">
										<img ref={(ref) => this.temp.hoverImgRefs[key] = ref}/>
									</div>
								</div>
									</div>);
								})
							}
						</div>);
			break;
			case "DEPARTMENT_INFO":
			case "RA_COMMENTS":
			case "LAST_RA_TABLE":
			case "USER_POINTS":
			case "LAST_RA_OBS_TABLE":
				return (<div key={this.state.i}>
						{this.tempData}
					</div>);
				break;
			case "POINTS_LINE":
				return this.props.fullPage ? (<canvas ref="canvas"></canvas>) : (<canvas ref="canvas" width="600" height="100" style={{minHeight: "200px", maxHeight: "200px"}}></canvas>);
			break;
			case "OBS_LOCAL_KPI":
				return this.props.fullPage ? (<canvas ref="canvas"></canvas>) : (<canvas ref="canvas" width="600" height="200" style={{minHeight: "400px", maxHeight: "400px"}}></canvas>);
			break;
			case "OBS_KPI":
				return this.props.fullPage ? <div style={{height: "100%", width: "100%"}}>
					<div className="KPIcontainer">
						<div className="KPIindicators" style={{flexDirection: "row"}}>
							<div className="KPIindicator" style={{paddingRight: "20px"}}>
								MTD
								<div className="indicatorCircle" ref="monthIndicator"></div>
							</div>
							<div className="KPIindicator">
								YTD
								<div className="indicatorCircle" ref="ytdIndicator"></div>
							</div>
						</div>
					</div>
					<canvas ref="canvas"></canvas>
				</div> :  <div className="KPIcontainer">
					<div className="KPIindicators">
						<div className="KPIindicator">
							MTD
							<div className="indicatorCircle" ref="monthIndicator"></div>
						</div>
						<div className="KPIindicator">
							YTD
							<div className="indicatorCircle" ref="ytdIndicator"></div>
						</div>
					</div>
					<canvas ref="canvas" style={{minHeight: "200px", maxHeight: "200px", paddingRight: "15px"}}></canvas>
				</div>;
				break;
			default:
					//console.log("Default type", this.props.type);
				return (<canvas ref="canvas" style={{...this.props.style}}></canvas>);
			break;
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/UI/Chart/Chart.js